import {
  Avatar as ChakraAvatar,
  AvatarProps,
  Circle,
  createIcon,
  Flex,
  Box,
} from '@chakra-ui/react';
import { theme } from '../../themes/theme';

export const Avatar = (props: AvatarProps) => {
  const { children, src, size = 'md', ...rest } = props;

  if (!src) {
    const { width, height } = theme.components.Avatar.sizes[size].container;
    return (
      <Circle
        backgroundColor="#DDDEF180"
        size={width}
        display="flex"
        justifyContent="center"
        alignItems="center"
        position="relative"
      >
        <OutpostLogo w={width} h={height} />
        {children && (
          <Flex
            position="absolute"
            width="100%"
            height="100%"
            justifyContent="flex-end"
            alignItems="flex-end"
          >
            <Box
              border="3px solid white"
              height="20px"
              width="20px"
              position="relative"
              borderRadius="full"
            >
              {children}
            </Box>
          </Flex>
        )}
      </Circle>
    );
  }

  return (
    <ChakraAvatar
      src={src}
      size={size}
      position="relative"
      bgColor="white"
      p="2px"
      _after={{
        content: "''",
        position: 'absolute',
        top: '0',
        left: '0',
        borderRadius: 'full',
        boxShadow: 'inner',
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        maxWidth: '100%',
        minWidth: '100%',
        minHeight: '100%',
        maxHeight: '100%',
      }}
      {...rest}
    >
      {children}
    </ChakraAvatar>
  );
};

const OutpostLogo = createIcon({
  displayName: 'OutpostLogo',
  viewBox: '0 0 61 61',
  path: (
    <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="30.8158" cy="30.4459" r="30.1842" fill="white" />
      <path
        d="M52.62 26.3739C51.7605 22.8625 50.2265 19.6086 48.1274 16.8441C46.2724 14.3961 44.0229 12.3687 41.4985 10.8699C38.1383 8.86466 34.3969 7.81401 30.5973 7.80859C25.7856 7.80859 21.2783 9.5095 17.5614 12.7282C13.3487 16.4185 10.3282 21.5743 8.96643 27.3992C7.52826 33.4979 8.0692 39.7376 10.4888 44.9758C10.8934 45.8473 11.3591 46.6805 11.8816 47.4677C14.0308 50.7194 16.9023 52.6382 20.1592 53.0172C20.556 53.0611 20.9528 53.0849 21.3723 53.0849C24.5255 53.0849 27.7404 51.7648 30.6669 49.2675L31.1722 48.8336C32.0533 49.8424 33.6825 51.5927 34.5279 52.3489C34.772 52.5664 35.0543 52.7227 35.3559 52.8072C35.6576 52.8918 35.9717 52.9028 36.2774 52.8394C36.5831 52.776 36.8734 52.6397 37.1288 52.4395C37.3843 52.2394 37.5991 51.9801 37.759 51.6788C38.031 51.1592 38.1268 50.5456 38.0284 49.9521C37.9301 49.3587 37.6444 48.8258 37.2245 48.4527C36.6641 47.9511 35.341 46.5339 34.6251 45.7375L35.0608 45.3054C36.2341 44.0609 37.3345 42.7313 38.355 41.325C40.3454 38.5402 41.5665 35.8323 42.0897 33.0622C42.3812 31.5197 42.3541 29.922 42.0103 28.3934C41.6783 26.9037 41.0282 25.5289 40.117 24.3892C39.3445 23.4248 38.3803 22.6818 37.3039 22.2214C36.1454 21.7302 34.8976 21.5699 33.6712 21.7546C31.522 22.0512 29.3632 23.2193 27.5881 25.0502C25.771 26.925 24.5628 29.2942 24.1871 31.7201C24.1692 31.8355 24.153 31.949 24.1385 32.0662C23.9569 33.5388 24.0295 35.0372 24.3522 36.4786C24.5279 37.2644 24.758 38.0333 25.0406 38.7783C25.1075 38.9592 25.1832 39.1358 25.2673 39.3074C25.4487 39.6736 25.6609 40.0397 25.8665 40.3766C25.941 40.4993 26.0139 40.6201 26.0852 40.7428L28.5145 44.8971C26.3427 46.4918 23.3854 48.1396 21.3609 48.1396C21.1051 48.1396 20.8494 48.1249 20.5949 48.0957C18.5218 47.8577 16.8148 46.6841 15.3766 44.5071C14.9981 43.9279 14.6607 43.3157 14.3677 42.6762C10.4807 34.2816 13.0574 22.8494 20.2175 16.65C23.1813 14.0867 26.7978 12.7264 30.6782 12.7264C33.3605 12.7197 36.0121 13.3711 38.45 14.6355C40.8879 15.8999 43.0541 17.7472 44.7992 20.05C48.1436 24.4734 49.6012 30.1657 48.9048 36.0813C48.3719 40.6421 46.2163 44.9575 42.6533 48.5699C42.3234 48.9032 42.0909 49.342 41.9866 49.828C41.8823 50.3141 41.9111 50.8245 42.0691 51.2917C42.2272 51.7588 42.5071 52.1607 42.8717 52.444C43.2363 52.7272 43.6684 52.8786 44.1109 52.878C44.657 52.8771 45.1836 52.6483 45.5895 52.2354C49.9235 47.8266 52.5715 42.4693 53.2468 36.7405C53.6636 33.2727 53.4503 29.7453 52.62 26.3739ZM28.4886 32.5715C28.9291 29.7373 31.5431 27.033 34.1992 26.6669C34.3524 26.6465 34.5065 26.6361 34.6607 26.6357C35.0794 26.6293 35.4945 26.724 35.8783 26.9134C36.262 27.1029 36.6056 27.3827 36.886 27.7343C37.7525 28.8072 38.1039 30.4532 37.8043 32.0314C37.0528 36.0044 33.6048 40.2155 31.9642 42.0464L31.4589 41.3378C29.7697 38.6977 28.0141 35.6236 28.4886 32.5715Z"
        fill="#3E1191"
      />
    </svg>
  ),
});
